module.exports = __webpack_public_path__ + "9f4c6e61ac2d47fe0b796a7244eed357.png";